/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
import { routes } from "@bvi/admin-panel/api-routes";
import { apiContainer, getItemTags, getListTag, invalidateTags, provideTagsList, TagTypes, WithId } from "@bvi/admin-panel/shared/api";
import { getResponseData } from "@bvi/api-interfaces/response";
import { IManageBaseListResponse, IManageBaseResponse } from '@bvi/api-interfaces/response/manage-base-data';

export const perpetratorApi = apiContainer.injectEndpoints({
  endpoints: (builder) => ({
    getPerpetratorList: builder.query<IManageBaseListResponse, void>({
      query: () => ({
        url: routes.perpetrator.findAll(),
        method: 'GET',
      }),
      providesTags: (result) =>
        result
          ? [
            ...getItemTags(TagTypes.PERPETRATOR, getResponseData(result)),
            getListTag(TagTypes.PERPETRATOR),
          ]
          : [getListTag(TagTypes.PERPETRATOR)],
    }),

    getByIdPerpetrator: builder.query<IManageBaseResponse, number>({
      query: (id) => ({
        url: routes.perpetrator.findOne(),
        method: 'GET',
        params: { id },
      }),
      providesTags: provideTagsList(TagTypes.PERPETRATOR)
    }),

    createPerpetrator: builder.mutation<
      IManageBaseResponse,
      { name: string }
    >({
      query: (data) => ({
        url: routes.perpetrator.create(),
        method: 'POST',
        data,
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.PERPETRATOR)),
    }),

    updatePerpetrator: builder.mutation<
      IManageBaseResponse,
      WithId<{ name: string }>
    >({
      query: ([id, data]) => ({
        url: routes.perpetrator.update(),
        method: 'PUT',
        data: { id, name: data.name },
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.PERPETRATOR)),
    }),

    deletePerpetrator: builder.mutation<void, number>({
      query: (id) => ({
        url: routes.perpetrator.remove(),
        method: 'DELETE',
        params: { id },
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.PERPETRATOR)),
    }),
  }),
});

export const {
  useGetPerpetratorListQuery,
  useLazyGetPerpetratorListQuery,
  useGetByIdPerpetratorQuery,
  useLazyGetByIdPerpetratorQuery,
  useCreatePerpetratorMutation,
  useUpdatePerpetratorMutation,
  useDeletePerpetratorMutation
} = perpetratorApi;


